const DefaultData = {
  APISERVERURL: "https://b2cclienttravel.azurewebsites.net/api/",
  APILOCALURL: "http://localhost:5126/api/",
  APIACTIVEURL: "https://zotraiapi.azurewebsites.net/api/",
  SERVICEFEE: "200",
  // TENANTID: "trawtel",
  // DEFAULTCOMPANYID: "efd32bd2-6639-42ed-9b1a-7e262da1be07",
  // DEFAULTBRANCHID: "d6c4fbf0-f59b-4e38-a8f5-ea643ca4eaaf",
  // DEFAULTRKEY: "rzp_test_RAGPPl9FIWDkzP",
  // APPLICATIONTYPE: "DEVELOPMENT",
  // DEFAULTCURRENCY: "INR",
  // WEBSITE: "https://myfirstbooking.in",
  // DEFAULTCOMPANYEMAIL: "support@myfirstbooking.in",
  // DEFAULTCOMPANYPHONENUMBER: "9177656344",
  // DEFAULTCOMPANYGST: "36ANVPM2246A1Z0",
  // DEFAULTCOMPANYNAME: "MYFIRSTBOOKING",
  // DEFAULTBRANDNAME: "MYFIRSTBOOKING",
  // DEFAULTCOMPANYADDRESS: "HYDERABAD, TELANGANA",
  // FACEBOOKURL: "https://www.facebook.com/myfirstbooking",
  // TWITTERURL: "https://x.com/myfirstbooking",
  // INSTGRAMURL: "https://www.instagram.com/myfirstbooking",
  // THEMECOLOR1: " #2F6F4E ",
  // THEMECOLOR2: "#1a1a1a",
  // THEMECOLOR3: "#ffffff",
  // THEMECOLOR4: "#000000",
  // THEMECOLOR5: "#1f3a5e",
  // LANDINGPAGETITLE: "AI-Powered Corporate Travel Desk for Modern Enterprises",
  // LANDINGPAGESUBTITLE:"Streamline bookings, control costs, and manage business travel intelligently.",
  // B2BWEBSITE: "https://b2b.trawtel.com/",
  // FOOTERCOPYRIGHTS: "2017 - 2025 MYFIRSTBOOKING.",
  // FOOTERSUBTITLE:
  //   "We make your dream more beautiful & enjoyable with lots of happiness.",
 COMPANYTYPE: "CORPORATE",
  USERTYPE: "CORPORATE",
  PLANTYPE: "TRIAL",
  DOMESTICFLIGHTFEE: "200",
  INTERNATIONALFLIGHTFEE: "400",
  DOMESTICHOTELBOOKINGFEE: "300",
  INTERNATIONALHOTELBOOKINGFEE: "800",
  BUSBOOKINGFEE: "50",
};

export default DefaultData;
